import { render, staticRenderFns } from "./PickedWordsControls.vue?vue&type=template&id=29eb256c&scoped=true&"
import script from "./PickedWordsControls.vue?vue&type=script&lang=js&"
export * from "./PickedWordsControls.vue?vue&type=script&lang=js&"
import style0 from "./PickedWordsControls.vue?vue&type=style&index=0&id=29eb256c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29eb256c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
